export const token = (state) => {
  return state.token;
};
export const verify = (state) => {
  return state.verify;
};
